export enum CardActions {
  CRD_EMIT = 'CRD_EMIT',
  CRD_PERSONALIZE = 'CRD_PERSONALIZE',
  CRD_UNPERSONALIZE = 'CRD_UNPERSONALIZE',
  CRD_REMIT = 'CRD_REMIT',
  CRD_EXPIRE = 'CRD_EXPIRE',
  CRD_RENEW = 'CRD_RENEW',
  CRD_UNBLOCK = 'CRD_UNBLOCK',
  CRD_BLOCK = 'CRD_BLOCK',
  CRD_DEACTIVATE = 'CRD_DEACTIVATE',
  CRD_LOSE = 'CRD_LOSE',
  CRD_FIND = 'CRD_FIND',
  CRD_ACTIVATE = 'CRD_ACTIVATE',
  CRD_IMPORT = 'CRD_IMPORT',
}
